/* istanbul ignore file */
import { FlowEntry, FlowRoute } from '../../types'

const laterOnboarding: FlowEntry[] = [
  {
    page: FlowRoute.Welcome,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.LaterSuitabilityQuestions,
      },
    ],
    progress: { stepIndex: 0, stepPartialProgress: 0 },
  },
  {
    page: FlowRoute.LaterSuitabilityQuestions,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.Analyzing,
      },
    ],
    progress: { stepIndex: 1 },
  },
  {
    page: FlowRoute.Analyzing,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.LaterIraRecommendation,
      },
    ],
    progress: { stepIndex: 1, stepPartialProgress: 37 },
  },
  {
    page: FlowRoute.LaterIraRecommendation,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.SelectPortfolioTheme,
      },
    ],
    progress: { stepIndex: 2 },
  },
  {
    page: FlowRoute.SelectPortfolioTheme,
    actions: [
      { name: 'next', stepEvent: 'portfolio_breakdown', goTo: () => FlowRoute.PreviewPortfolio },
      {
        name: 'learn_more',
        stepEvent: 'esg_education_flow',
        goTo: () => FlowRoute.ESGEducationFlow,
      },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.PreviewPortfolio,
    actions: [
      {
        name: 'continue',
        stepEvent: 'portfolio_breakdown',
        goTo: () => FlowRoute.RecurringInvestment,
      },
      { name: 'learn_more_esg', stepEvent: 'about_esg', goTo: () => FlowRoute.AboutESG },
      {
        name: 'about_portfolio',
        stepEvent: 'about_portfolio',
        goTo: () => FlowRoute.AboutPortfolio,
      },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.AboutESG,
    actions: [{ name: 'goBack', stepEvent: 'goBack', goTo: () => FlowRoute.PreviewPortfolio }],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 94,
      stepOverallProgress: 70,
    },
  },
  {
    page: FlowRoute.AboutPortfolio,
    actions: [{ name: 'goBack', stepEvent: 'goBack', goTo: () => FlowRoute.PreviewPortfolio }],
    progress: {
      stepIndex: 2,
      stepPartialProgress: 94,
      stepOverallProgress: 70,
    },
  },
  {
    page: FlowRoute.ESGEducationFlow,
    actions: [{ name: 'done', stepEvent: 'done_tour', goTo: () => FlowRoute.SelectPortfolioTheme }],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.RecurringInvestment,
    actions: [
      {
        name: 'one-time',
        goTo: () => FlowRoute.OneTimeInvestment,
      },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
      { name: 'continue', goTo: () => FlowRoute.Success },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.OneTimeInvestment,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.Success,
      },
      { name: 'link-account', goTo: () => FlowRoute.Institutions },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.Funding,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.Institutions,
      },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.Institutions,
    actions: [
      {
        name: 'choose',
        goTo: () => FlowRoute.ChooseFundingSource,
      },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'direct', goTo: () => FlowRoute.DirectBankIntegration },
      { name: 'skip', goTo: () => FlowRoute.Success },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.DirectBankIntegration,
    actions: [
      { name: 'choose', goTo: () => FlowRoute.ChooseFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'skip', goTo: () => FlowRoute.Success },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.ManualFundingSource,
    actions: [
      {
        name: 'skip',
        goTo: () => FlowRoute.Success,
      },
      { name: 'continue', goTo: () => FlowRoute.BankLinkSuccess },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.ChooseFundingSource,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.BankLinkSuccess,
      },
      { name: 'manual', goTo: () => FlowRoute.ManualFundingSource },
      { name: 'different-bank', goTo: () => FlowRoute.Institutions },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.BankLinkSuccess,
    actions: [
      {
        name: 'continue',
        goTo: () => FlowRoute.RecurringInvestment,
      },
    ],
    progress: { stepIndex: 3 },
  },
  {
    page: FlowRoute.RoundUpsInterstitial,
    actions: [{ name: 'continue', goTo: () => FlowRoute.RecurringInvestment }],
    progress: {
      stepIndex: 1,
      stepPartialProgress: 50,
      stepOverallProgress: 15,
    },
  },
  {
    page: FlowRoute.Success,
    actions: [],
    progress: { stepIndex: 4 },
  },
]

export default laterOnboarding
